import { makeStyles } from "@material-ui/core/styles"

const statsCardSection = makeStyles(() => ({
  title: {
    textAlign: "center",
    margin: "20px 0px",
  },
}))

export default statsCardSection
